<main class="mb-4">
  <div class="row ">
    <div class="col-sm-12">
      <h2 class="text-primary mb-4">{{'PrestacoesMorte.StepSender.Cards.SenderObservations.Title' | translate}}</h2>
    </div>
  </div>
  <div class="row">
    <!--Observações-->
    <div class="col-sm-12">
      <label for="observations">{{'PrestacoesMorte.StepSender.Cards.SenderObservations.Fields.AdditionalObservations' | translate}}</label>
      <div class="position-relative">
        <textarea class="form-control input-right" rows="5" type="text"
                  [(ngModel)]="cardData.additionalObservations"
                  [maxLength]="300"
                  #additionalObservations="ngModel" name="additionalObservations"
                  placeholder="{{'PrestacoesMorte.StepSender.Cards.SenderObservations.Fields.AdditionalObservationsPlaceholder' | translate}}"
                  messageFieldType="string"></textarea>
      </div>
    </div>
  </div>
</main>
